<template>
  <div class="activity-dashboard">
    <div class="dashboard">
      <div class="dashboard-grid">
        <my-tasks-summary ref="summary" class="grid-full" :only-mine="onlyMine" />
        <my-external-tasks-list
          ref="externalList"
          class="grid-full"
          :isDetail="true"
          :only-mine="onlyMine"
          @form-opened="onFormOpened('external')"
          @task-done="onTaskDone"
        />
        <my-internal-tasks-list
          ref="internalList"
          class="grid-full"
          :isDetail="true"
          :only-mine="onlyMine"
          @form-opened="onFormOpened('internal')"
          @task-done="onTaskDone"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_TYPES } from '@/pages/task/task/store'
import MyExternalTasksList from '../dashboard/my-external-tasks/MyExternalTasksList.vue'
import MyInternalTasksList from '../dashboard/my-internal-tasks/MyInternalTasksList.vue'
import MyTasksSummary from '../dashboard/my-tasks-summary/MyTasksSummary.vue'

export default {
  name: 'ActivityDashboard',
  components: {
    MyExternalTasksList,
    MyInternalTasksList,
    MyTasksSummary
  },
  props: {
    onlyMine: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters({
      taskDetail: TASK_TYPES.GENERIC.task.task.DETAIL.GETTERS.detail
    })
  },
  watch: {
    '$route.query.openTaskId' (val) {
      this.handleOpenTaskId(val)
    }
  },
  created () {
    this.handleOpenTaskId(this.$route && this.$route.query && this.$route.query.openTaskId)
  },
  methods: {
    ...mapActions({
      retrieveTask: TASK_TYPES.GENERIC.task.task.DETAIL.ACTIONS.retrieve
    }),
    onFormOpened (source) {
      const other = source === 'external' ? this.$refs.internalList : this.$refs.externalList
      if (other && typeof other.closeForms === 'function') {
        other.closeForms()
      }
    },
    onTaskDone () {
      // A task was marked done in one of the lists: reload the summary counters.
      if (this.$refs.summary && typeof this.$refs.summary.refresh === 'function') {
        this.$refs.summary.refresh()
      }
    },
    handleOpenTaskId (openTaskId) {
      // Notifica "aggiunto come incaricato": apre il dettaglio inline del ticket nella
      // lista corretta (interna = category type 'company', altrimenti esterna).
      if (!openTaskId) return
      const id = parseInt(openTaskId, 10)
      if (Number.isNaN(id)) return
      this.retrieveTask({ id }).then(() => {
        const isInternal = this.taskDetail && this.taskDetail.category_type_code === 'company'
        const list = isInternal ? this.$refs.internalList : this.$refs.externalList
        this.$nextTick(() => {
          if (list && typeof list.openDetailForm === 'function') {
            list.openDetailForm(id)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
